/* PRD GALLERY */
const galleryID = document.querySelectorAll('.swiper-gallery');
//console.log(galleryID);

//multiply delay by random number
const galleryFirstSlide = getRandomIntInclusive(1, 3);

galleryID.forEach(el => {
  //console.log(el);
  const uniqID = el.getAttribute('unique-id');
  const autoplay = el.getAttribute('autoplay');
  const loop = el.getAttribute('loop');
  let loopAttr = true;
  if (loop == 'false') {
    loopAttr = false;    
  }
  
  const playdelay = el.getAttribute('delay');
  let autoplayAttr = {};
  if (autoplay == 'true') {
    autoplayAttr = {
      delay: +playdelay * galleryFirstSlide,
      disableOnInteraction: true,
    };
  } else {
    autoplayAttr = false;
  }

  const slideNavigation = el.getAttribute('slide-navigation');
  //console.log(slideNavigation);
  const swiperName = el.id;
  //console.log(swiperName);
  const swiperTemp = document.querySelector(`#${swiperName}`);
  //console.log(swiperTemp);
  const nodes = swiperTemp.childNodes;
  //console.log(nodes);

  function deepestChild(id, element) {
    var nodes = document.querySelectorAll(`#${id} ${element}`);
    if (!nodes.length) return false;
    return nodes[nodes.length - 1];
  }
  //const deepEl = deepestChild('featuredProducts-gallery-seacula', 'a');
  //console.log(deepEl);

  //const itemsNested = document.querySelectorAll("[id^=featuredProducts-gallery-seacula] > div.swiper-wrapper > div.swiper-slide");
  //console.log(itemsNested);
  // itemsNested.forEach (item => {
  // //const itemNestedText = itemsNested.textContent;
  // console.log(item.id);
  // } );

  // function handleDuplicateSlide() {
  //   console.log("handle duplicate slide");
  //   let swiperDuplicates = document.querySelectorAll( '[id^=featuredProducts-gallery-seacula] > div.swiper-wrapper > div.swiper-slide-duplicate' );

  //   //console.log(swiperDuplicates);
  //   swiperDuplicates.forEach( function ( item, index ) {
  //     const idDup = item.getAttribute('id');
  //     //console.log(idDup);
  //       //item.setAttribute('id', idDup + '-' + index);
  //   })
  // }

  const children = swiperTemp.children;
  //console.log(children);
  if (slideNavigation == 'false') {
    Array.from(children).forEach(item => {
      // item.style.display = "inline-block";
      //console.log(item);
      if (item.classList.contains('swiper-button-prev-gallery')) {
        item.classList.add('d-none');
      }
      if (item.classList.contains('swiper-button-next-gallery')) {
        item.classList.add('d-none');
      }
    });
  }

  //use stopImmediatepropagation in productinfo modal
  const $swiperName = new Swiper(`#${swiperName}`, {
    loop: loopAttr,
    autoplay: autoplayAttr,
    preloadImages: false,
    preventClicksPropagation: false,
    preventClicks: false,
    a11y: false,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: {
      invert: true,
    },
    breakpoints: {
      350: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
        },
      1400: {
        slidesPerView: 4,
      },
    },
    spaceBetween: 25,
    navigation: {
      nextEl: '.swiper-button-next-gallery',
      prevEl: '.swiper-button-prev-gallery',
    },
    on: {
      init: function (e) {
         e.mousewheel.disable();
        //console.log("handle duplicate slide, set unique id attribute by adding index to existing id");
        const swiperDuplicates = document.querySelectorAll(
          `[id^=${swiperName}] > div.swiper-wrapper > div.swiper-slide-duplicate > div.card > div.card-img-top > div.img-wrapper > div.inner-img > a`
        );

        if (swiperDuplicates.length > 0) {
          //console.log(swiperDuplicates);
          swiperDuplicates.forEach(function (item, index) {
            //console.log(item);
            const idDup = item.getAttribute('id');
            //console.log(idDup);
            item.setAttribute('id', idDup + '-' + index);
            //console.log(item);
          });
        }
      },
    },
  });
});

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
}

function submitForm(fmName,id) {
    const formCard = document.getElementById(fmName);
    //console.log(formCard);
    if (formCard) {
        addCartItem(id);
    }
}

if (scriptsLoaded) scriptsLoaded.push('prd-gallery.js');